export type ImSyncAppliedSummary = {
  created?: number;
  updated?: number;
  markedLeft?: number;
  departmentsSynced?: number;
  deptPathsRefreshed?: number;
};

/** @deprecated 使用 ImSyncAppliedSummary */
export type DingtalkAppliedSummary = ImSyncAppliedSummary;

export function formatImSyncAppliedMessage(
  label: string,
  applied?: ImSyncAppliedSummary,
): string {
  if (!applied) return `${label}同步完成`;
  const parts = [
    `新增 ${applied.created ?? 0}`,
    `更新 ${applied.updated ?? 0}`,
    `离职 ${applied.markedLeft ?? 0}`,
  ];
  if (applied.departmentsSynced != null) {
    parts.push(`部门 ${applied.departmentsSynced}`);
    parts.push(`部门路径 ${applied.deptPathsRefreshed ?? 0} 人`);
  }
  return `${label}同步完成：${parts.join(' / ')}`;
}

/** @deprecated 使用 formatImSyncAppliedMessage */
export function formatDingtalkAppliedMessage(applied?: ImSyncAppliedSummary): string {
  return formatImSyncAppliedMessage('钉钉', applied);
}
